var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue, Inject } from 'vue-property-decorator';
import { INJECT_UICORE_DESIGNER } from "../../../../../../lib/utils/consts";
import StyleNameHeader from "../../../../../../lib/comps/PropPanel/StylePanel/comps/StyleNameHeader";
import WButton from "../../../../../../lib/builtin/components/Button";
import { StyleSheetEditModal } from './StyleSheetEditModal';
import { StyleSheetMultiSelect } from "../../../../../../lib/comps/PropPanel/StylePanel/comps/StyleTemplate/StyleSheetMultiSelect";
import { StyleSheetManageModal } from "../../../../../../lib/comps/PropPanel/StylePanel/comps/StyleTemplate/StyleSheetManageModal";
import * as styles from "./index.module.css";
const HelpText = `
      1.样式模板为当前组件已配置的样式集合 <br>
      2.你可以选择已有的模板，也可以保存当前的样式为新模板<br>
      3.模板可以二次编辑,可以多个模板应用至一个组件上<br>
      `;
let StyleTemplagePanel = class StyleTemplagePanel extends Vue {
  constructor() {
    super(...arguments);
    this.manageModalVisible = false;
  }
  get stylePanelState() {
    return this.designer.stylePanelState;
  }
  openCreateModal() {
    var _this$designer$active;
    const source = this.stylePanelState.style2Source();
    const sourceWithInterop = this.stylePanelState.style2Source({
      ignoreInterop: false
    });
    const hasInterop = source !== sourceWithInterop;
    const warningText = hasInterop ? '样式模板中的{{ 插值 }} 不会生效' : '';
    const sheet = this.stylePanelState.generateStyleSheet('', source, {
      componentType: (_this$designer$active = this.designer.activeComp) === null || _this$designer$active === void 0 ? void 0 : _this$designer$active.type
    });
    this.$refs.editModal.open(sheet, {
      warning: warningText
    });
  }
  openManageModal() {
    this.manageModalVisible = true;
  }
  renderManage() {
    const h = this.$createElement;
    return h("div", {
      "class": "uc-slider-input-rapper",
      "style": "margin-left:0"
    }, [h(StyleSheetMultiSelect, {
      "attrs": {
        "allStyleSheet": this.stylePanelState.styleSheetList,
        "selectedSheet": this.stylePanelState.currentActiveStyleSheetList
      },
      "on": {
        "change": ev => this.stylePanelState.assignStyleSheet(ev, this.designer.compPath)
      }
    })]);
  }
  render() {
    const h = arguments[0];
    return h("div", {
      "class": styles.templatePanel
    }, [h("div", {
      "class": styles.templatePanelButtonGroup
    }, [h(WButton, {
      "attrs": {
        "icon": "plus"
      },
      "on": {
        "click": this.openCreateModal
      },
      "class": styles.createNewButton
    }, ["\u65B0\u589E\u6837\u5F0F\u6A21\u677F"]), h(WButton, {
      "attrs": {
        "icon": "pencil"
      },
      "on": {
        "click": this.openManageModal
      },
      "class": styles.openManageButton
    }, ["\u7BA1\u7406\u6A21\u677F"])]), h("style-name-header", {
      "attrs": {
        "name": '选择样式模板',
        "helpText": HelpText
      }
    }, [this.renderManage()]), h("div", [h(StyleSheetEditModal, {
      "ref": "editModal",
      "attrs": {
        "isCreateNew": true,
        "width": "1000px"
      }
    }), this.manageModalVisible ? h(StyleSheetManageModal, {
      "model": {
        value: this.manageModalVisible,
        callback: $$v => {
          this.manageModalVisible = $$v;
        }
      }
    }) : null])]);
  }
};
__decorate([Inject({
  from: INJECT_UICORE_DESIGNER,
  default: null
})], StyleTemplagePanel.prototype, "designer", void 0);
StyleTemplagePanel = __decorate([Component({
  name: 'StyleTemplagePanel',
  components: {
    StyleNameHeader
  }
})], StyleTemplagePanel);
export { StyleTemplagePanel };
//# sourceMappingURL=StyleTemplatePanel.js.map
